import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import {VehicleValidationManagerService} from '../../services/vehicle-validation-manager.service';
import {FleetChecklistEditorService} from '../../services/fleet-checklist-editor.service';

import {SelectableVehicle} from '../../models/vehicle-validation';


@Component({
  selector: 'app-validation-vehicle-available',
  templateUrl: './validation-vehicle-available.component.html',
  styleUrls: ['./validation-vehicle-available.component.scss', '../../styles/styles-component.scss'],
})
export class ValidationVehicleAvailableComponent implements OnInit {
  constructor(
    public vehicleValidation: VehicleValidationManagerService,
    public editor: FleetChecklistEditorService
  ) { }
  get vehicleSelected() {
    return this.editor.vehicles
  }
  ngOnInit(): void {}
  toggleVehicleSelection(vehicle: SelectableVehicle): void {
    if(this.isVehicleSelected(vehicle)) {
      this.editor.removeVehicle(vehicle.id);
    } else {
      this.editor.addVehicle(vehicle);
    }
  }

  selectAllFiltered(): void {
    const filtered = this.vehicleValidation.getFilteredVehicles();
    filtered.forEach((vehicle) => {
      this.editor.addVehicle(vehicle);
    });
  }
  isVehicleSelected(vehicle: SelectableVehicle): boolean {
    return this.editor.existsVehicle(vehicle.id);
  }

  deselectAll(): void {
    this.editor.removeAllVehicles();
    this.clearFilters();
  }

  clearFilters(): void {
    this.vehicleValidation.clearFilters();
  }



  /*
    GETTERS & SETTERS
    Controls to be used in the template by FilterComponent
  */

  get vehicleSearchQuery(): string {
    return this.vehicleValidation.getSearchFilter();
  }
  set vehicleSearchQuery(val: string) {
    this.vehicleValidation.setSearchFilter(val);
  }

  get selectedOperation(): any {
    return this.vehicleValidation.getSelectedOperation();
  }
  set selectedOperation(val: any) {
    this.vehicleValidation.setOperation(val);
  }

  get selectedGroup(): any {
    return this.vehicleValidation.getSelectedGroup();
  }
  set selectedGroup(val: any) {
    this.vehicleValidation.setGroup(val);
  }

  get selectedConvoy(): any {
    return this.vehicleValidation.getSelectedConvoy();
  }
  set selectedConvoy(val: any) {
    this.vehicleValidation.setConvoy(val);
  }

  // Dropdown options derived from the service
  get operationsFilter(): any[] {
    return this.vehicleValidation.getOperations();
  }

  get filteredGroups(): any[] {
    return this.vehicleValidation.getFilteredGroups();
  }

  get filteredConvoys(): any[] {
    return this.vehicleValidation.getFilteredConvoys();
  }
}
